import React from 'react';

type FormatOption<T> = {
    label: React.ReactNode;
    subLabel?: string;
    value: T;
};

type FormatOptionsProps<T> = {
    option: FormatOption<T>;
    icon?: string;
    iconStyleClasses?: string;
    labelStyleClasses?: string;
    subLabelStyleClasses?: string;
};

const FormatOptionLabel = <T,>({
    option,
    icon,
    iconStyleClasses = '',
    labelStyleClasses = '',
    subLabelStyleClasses = '',
}: FormatOptionsProps<T>) => {
    return (
        <div className="d-flex align-items-center">
            {icon && (
                <span className={`material-symbols-outlined + ${iconStyleClasses}`}>{icon}</span>
            )}
            <span className={labelStyleClasses}>{option.label}</span>
            {option.subLabel && <span className={subLabelStyleClasses}>{option.subLabel}</span>}
        </div>
    );
};

export type { FormatOption, FormatOptionsProps };
export default FormatOptionLabel;
